import moment from 'moment'

export default (dateIso, dateFormat) => {
  const dobOnly = dateIso.split('T')
  const dtfiso = moment(dobOnly[0]).format(dateFormat)
  return dtfiso
}
